<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='变更带教' url='/cycle/entry/entriedlist'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部" @change="ManageSecChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">轮转科室：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.section" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">入科时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.entrydate" type="month" placeholder="入科时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column>
              <template slot="header">
                姓名<br>工号
              </template>
              <template slot-scope="scope">
                {{scope.row.StuName}}<br>{{scope.row.StuNo}}
              </template>
            </el-table-column>
            <el-table-column prop="ManageSecName" label="管理单元">
            </el-table-column>
            <el-table-column prop="CPSecName" label="轮转科室">
            </el-table-column>
            <el-table-column label="轮转时间" width="240">
              <template slot-scope="scope">
                {{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
              </template>
            </el-table-column>
            <el-table-column label="带教老师" width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.CPTecID!=null">
                  <div style="float: left;width: 50px;height: 36px;line-height: 36px;">
                    {{scope.row.CPTecName}}
                  </div>
                  <div style="float: left;width: 75px;height: 36px;line-height: 36px;">
                    <el-button @click="SetTec(scope.row)" type="text" size="medium">[变更]</el-button>
                  </div>
                </div>
                <!-- <div v-if="scope.row.CPStatus=='3'">无</div> -->
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
        <el-dialog width="50%" title="变更带教老师" :visible.sync="dialogFormVisible">
          <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form">
            <div class="form-group m-form__group row">
              <label class="col-xl-2 col-form-label">变更原因：</label>
              <div class="col-xl-10">
                <el-form-item prop="tecremark" :rules="{required: true, message: '变更原因不能为空', trigger: 'blur'}">
                  <el-input v-model="form.tecremark" placeholder="请输入变更原因"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-xl-2 col-form-label">选择带教：</label>
              <div class="col-xl-10">
                <div class="m-portlet__body" style="height: 300px;overflow: auto;">
                  <el-table v-loading="tecloading" :data="tectableData" stripe style="width: 100%" size="medium">
                    <el-table-column prop="TrueName" label="姓名">
                    </el-table-column>
                    <el-table-column prop="CardNo" label="工号">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="SaveTec(scope.row)" type="text" size="medium">选择</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EntriedList',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          truename: '',
          section: '',
          cardno: '',
          entrydate: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          secretarysec: ''
        },
        tableData: null,
        tectableData: null,
        secOptions: [],
        managesecOptions: [],
        dialogFormVisible: false,
        tecOption: null,
        form: {
          token: '',
          id: '',
          tecid: '',
          tecremark: ''
        },
        searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/GetEntriedList',
        loading: true,
        tecloading: false,
        fullscreenLoading: false
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      },
      formatFullDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      SetTec: function(row) {
        this.dialogFormVisible = true
        this.tectableData = []
        this.form.id = row.ID
        this.tecloading = true
        var that = this
        var args = {
          token: this.condition.token,
          section: row.CPSec
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APITeacher/CPTecList', args, function(data) {
          that.tectableData = data.Data
          that.tecloading = false
        }, null, null, null)
      },
      SaveTec: function(row) {
        if(this.form.tecremark == ''){
          this.$message({
            message: '变更原因不能为空',
            type: 'warning'
          })
          return
        }
        
        var args = {
          token: this.condition.token,
          id: this.form.id,
          tecid: row.TecID,
          tecremark:this.form.tecremark
        }
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/UpdateCyclePlanDetailTec', args)
          .then(res => {
            if (res.data.Code === 0) {
              that.$message({
                message: '设置成功',
                type: 'success'
              })
              console.log('设置成功')
              that.form.tecremark = ''
              that.dialogFormVisible = false
              that.$refs.btnSearch.Search()
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            that.$message({
              message: '设置失败',
              type: 'error'
            })
          })
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      ManageSecChange: function() {
        this.condition.section = ''
        this.secOptions = []
        this.LoadCPSec()
      },
      LoadCPSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel,
          mamagesec: this.condition.secretarysec
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      var date = new Date()
      var year = date.getFullYear()
      console.log(date.getMonth())
      var month = date.getMonth() + 1
      if (month > 12) {
        year = year + 1
        month = 1
      }
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      this.condition.entrydate = year + '-' + month
      this.LoadManageSec()
      this.LoadCPSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  .message-box {
    width: 600px;
  }

  .timeclass {
    width: 100%;
  }

  /deep/.el-table .cell {
    line-height: 25px;
  }

  /deep/.el-input {
    width: 220px;
  }
  
  .m-form.m-form--group-seperator-dashed .m-form__group{
    border-bottom: 0;
  }
</style>
